import React from "react";
import {
  Kitchen as KitchenIcon,
  Restaurant as RestaurantIcon,
  CleaningServices as CleaningIcon,
  Engineering as EngineeringIcon,
} from "@mui/icons-material";
import CategoryPageTemplate from "../CategoryPageTemplate";
import { kitchenFittingCategories } from "./kitchenFittingsData";

const KitchenFittingsPage: React.FC = () => {
  const features = [
    { icon: KitchenIcon, text: "Professional Kitchen Solutions" },
    { icon: RestaurantIcon, text: "Food Grade Materials" },
    { icon: CleaningIcon, text: "Easy Maintenance" },
    { icon: EngineeringIcon, text: "Precision Engineering" },
  ];

  return (
    <CategoryPageTemplate
      title="Kitchen Fittings Collection"
      subtitle="Premium Kitchen Solutions for Modern Cooking"
      description="Discover our comprehensive range of kitchen fittings including sinks, faucets, and accessories designed for modern kitchens. Each product combines functionality with style to enhance your cooking experience."
      categoryData={kitchenFittingCategories}
      categoryType="Kitchen Fitting"
      gradientCategory="Kitchen Fittings"
      icon={KitchenIcon}
      features={features}
    />
  );
};

export default KitchenFittingsPage;
